export const SIGN_VALIDATION_MESSAGES = {
  missingIcdCode: "Please add at least one ICD code before signing the visit.",
  missingChiefComplaint:
    "Please enter the Chief Complaint before signing the visit.",
} as const;
